import Icon from "@react-native-vector-icons/material-design-icons";
import theme from "assets/theme";
import React, { useContext } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import TooltipText from "webComponentsFormElements/TooltipText.component";
import { OrganizationContext } from "webContext/Organization.context";

const classes = StyleSheet.create({
  label: {
    fontWeight: theme.font.weight.medium,
    color: theme.color.darkGrey,
    marginLeft: 10,
    marginBottom: 5,
  },
  optionsContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    zIndex: -1,
  },
  inputRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    zIndex: -1,
  },
  optionLabel: {
    color: theme.color.darkGrey,
  },
});

export default function RadioSelect(props) {
  const { label, tooltip, options, value, onChange } = props;

  const { organizationColor } = useContext(OrganizationContext);

  return (
    <View>
      {tooltip ? (
        <TooltipText tooltip={tooltip}>{label}</TooltipText>
      ) : (
        <Text style={classes.label}>{label}</Text>
      )}
      <View style={classes.optionsContainer}>
        {options.map((option, index) => (
          <TouchableOpacity
            key={index}
            style={classes.inputRow}
            onPress={() => onChange(option.value)}
          >
            <Icon
              name={option.value === value ? "record-circle" : "circle-outline"}
              size={25}
              color={organizationColor}
            />
            {label && <Text style={classes.optionLabel}>{option.label}</Text>}
          </TouchableOpacity>
        ))}
      </View>
    </View>
  );
}
